 // I don't this - delet breakpoint or assign with myvars>
const breakpoints = {
	tiny: '320px',
	small: '576px',
	medium: '768px',
	large: '1024px',
	wide: '1360px',
  }
  
  const colors = {
	deploiwhite: 'rgba(255, 255, 255, 1)', // white
	deploiwhite_50: 'rgba(255, 255, 255, 0.5)', // white

	deploiorange: 'rgb(241, 96, 33, 1)',//'#f16021', // orange
	deploiorange_50:'rgba(241, 96, 33, 0.5)', // orange
	
	deploired: 'rgba(239, 65, 48, 1)', // red
	deploired_50: 'rgba(239, 65, 48, 0.5)', // red
	
	deploipink: 'rgba(243,134,175,1)', // pink
	deploipink_50: 'rgba(243,134,175,0.5)', // pink
	
	deploiyellow: 'rgba(250,205,58,1)', // yellow
	deploiyellow_50: 'rgba(250,205,58,0.5)', // yellow
	
	deploigreen: 'rgba(70,167,72,1)', // green
	deploigreen_50: 'rgba(70,167,72,0.5)', // green
	
	deploiblue: 'rgba(0,159,218,1)', // blue
	deploiblue_50: 'rgba(0,159,218,0.5)', // blue
	
	deploipurple: 'rgba(107,72,157,1)', // purple
	deploipurple_50: 'rgba(107,72,157,0.5)', // purple

	deploimediumgrey: 'rgba(209, 211, 212, 1)', // mediumgrey
	deploimediumkgrey_50: 'gba(209, 211, 212, 0.5)', // mediumgrey

	deploidarkgrey: 'rgba(167,169, 172, 1)', // darkgrey
	deploidarkgrey_50: 'rgba(167,169, 172,0.5)', // darkgrey

 //@deploi-darkgrey:rgba(167,169, 172, 1); // darkgrey
 //@deploi-mediumgrey:rgba(209, 211, 212, 1); // mediumgrey
 //@deploi-lightgrey:rgba(231, 231, 232, 1); // lightgrey
 //@deploi-black:rgba(0, 0, 0, 1); // black

  }

  const measurements = {
	calcheight: 0, //set   
	lineheight:13, // delete probably
  }
export { breakpoints , colors, measurements }; 

 
  
